<template>
  <div>
    <v-bottom-navigation app fixed grow class="hidden-sm-and-up">
      <v-btn x-large v-if="hasPrev" icon @click="emitPrev"><v-icon>mdi-arrow-left</v-icon></v-btn>
      <v-spacer />
      <v-btn :disabled="disableNext" x-large v-if="hasNext" color="green" icon @click="emitNext">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-card-actions class="card-actions hidden-sm-and-down d-sm-inline">
      <v-row>
        <v-col>
          <v-row justify="start">
            <v-btn id="prev" large rounded v-if="hasPrev" elevation="0" @click="emitPrev"
              ><v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </v-row>
        </v-col>
        <v-col>
          <v-row justify="end">
            <v-btn
              id="next"
              :disabled="disableNext"
              large
              rounded
              v-if="hasNext"
              color="green"
              elevation="0"
              @click="emitNext"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card-actions>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class BackAndForthFooter extends Vue {
  @Prop({ default: true })
  hasNext!: boolean;

  @Prop({ default: true })
  hasPrev!: boolean;

  @Prop({ default: false })
  disableNext!: boolean;

  emitNext() {
    this.$emit("next", true);
  }
  emitPrev() {
    this.$emit("prev", true);
  }
}
</script>
